import {
    LOAD_DELIVERY_SETTINGS_SUCCESS,
    UPDATE_DELIVERY_SETTINGS_SUCCESS,
    RESET_DELIVERY_SETTINGS
} from '../../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_DELIVERY_SETTINGS_SUCCESS:
            return action.payload;
        case UPDATE_DELIVERY_SETTINGS_SUCCESS:
            return action.payload;
        case RESET_DELIVERY_SETTINGS:
            return INITIAL_STATE;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/DeliveryReducer.js